export default "__VITE_ASSET__aea4d817__"